import React from 'react'
import AddIcon from '@mui/icons-material/Add'
import ArrowBackIcon from '@mui/icons-material/ArrowBack'
import ArrowDownwardIcon from '@mui/icons-material/ArrowDownward'
import ArrowForwardIcon from '@mui/icons-material/ArrowForward'
import ArrowUpwardIcon from '@mui/icons-material/ArrowUpward'
import CancelIcon from '@mui/icons-material/Cancel'
import CheckIcon from '@mui/icons-material/Check'
import CheckBoxIcon from '@mui/icons-material/CheckBox'
import CheckBoxOutlineBlankIcon from '@mui/icons-material/CheckBoxOutlineBlank'
import CheckCircleIcon from '@mui/icons-material/CheckCircle'
import CheckCircleOutlineIcon from '@mui/icons-material/CheckCircleOutline'
import ChevronLeftIcon from '@mui/icons-material/ChevronLeft'
import ChevronLeftRoundedIcon from '@mui/icons-material/ChevronLeftRounded'
import ChevronRightIcon from '@mui/icons-material/ChevronRight'
import CloseIcon from '@mui/icons-material/Close'
import CommentIcon from '@mui/icons-material/Comment'
import ContentCopyIcon from '@mui/icons-material/ContentCopy'
import CropIcon from '@mui/icons-material/Crop'
import DateRangeIcon from '@mui/icons-material/DateRange'
import DeleteIcon from '@mui/icons-material/Delete'
import DeleteOutlineIcon from '@mui/icons-material/DeleteOutline'
import DragIndicatorIcon from '@mui/icons-material/DragIndicator'
import EventRepeatIcon from '@mui/icons-material/EventRepeat'
import ExpandLessIcon from '@mui/icons-material/ExpandLess'
import ExpandMoreIcon from '@mui/icons-material/ExpandMore'
import ExpandMoreRoundedIcon from '@mui/icons-material/ExpandMoreRounded'
import FacebookIcon from '@mui/icons-material/Facebook'
import FilterAltIcon from '@mui/icons-material/FilterAlt'
import FormatBoldIcon from '@mui/icons-material/FormatBold'
import FormatItalicIcon from '@mui/icons-material/FormatItalic'
import FormatListBulletedIcon from '@mui/icons-material/FormatListBulleted'
import FormatListNumberedIcon from '@mui/icons-material/FormatListNumbered'
import FormatUnderlinedIcon from '@mui/icons-material/FormatUnderlined'
import FullscreenIcon from '@mui/icons-material/Fullscreen'
import InfoIcon from '@mui/icons-material/Info'
import InfoOutlinedIcon from '@mui/icons-material/InfoOutlined'
import InstagramIcon from '@mui/icons-material/Instagram'
import KeyboardArrowDownIcon from '@mui/icons-material/KeyboardArrowDown'
import KeyboardArrowLeftIcon from '@mui/icons-material/KeyboardArrowLeft'
import KeyboardArrowRightIcon from '@mui/icons-material/KeyboardArrowRight'
import KeyboardArrowRightRoundedIcon from '@mui/icons-material/KeyboardArrowRightRounded'
import KeyboardArrowUpIcon from '@mui/icons-material/KeyboardArrowUp'
import LinkIcon from '@mui/icons-material/Link'
import LocationOnIcon from '@mui/icons-material/LocationOn'
import MenuIcon from '@mui/icons-material/Menu'
import MoreHorizIcon from '@mui/icons-material/MoreHoriz'
import NotesIcon from '@mui/icons-material/Notes'
import NotificationsIcon from '@mui/icons-material/Notifications'
import PersonOutlinedIcon from '@mui/icons-material/PersonOutlined'
import RadioButtonCheckedIcon from '@mui/icons-material/RadioButtonChecked'
import RadioButtonUncheckedIcon from '@mui/icons-material/RadioButtonUnchecked'
import RemoveIcon from '@mui/icons-material/Remove'
import ReportIcon from '@mui/icons-material/Report'
import ScheduleIcon from '@mui/icons-material/Schedule'
import SearchIcon from '@mui/icons-material/Search'
import SettingsIcon from '@mui/icons-material/Settings'
import ShareIcon from '@mui/icons-material/Share'
import SmartDisplayIcon from '@mui/icons-material/SmartDisplay'
import StarIcon from '@mui/icons-material/Star'
import StarBorderIcon from '@mui/icons-material/StarBorder'
import TextFieldsIcon from '@mui/icons-material/TextFields'
import TodayOutlinedIcon from '@mui/icons-material/TodayOutlined'
import TuneIcon from '@mui/icons-material/Tune'
import TwitterIcon from '@mui/icons-material/Twitter'
import UnfoldLessIcon from '@mui/icons-material/UnfoldLess'
import UnfoldMoreIcon from '@mui/icons-material/UnfoldMore'
import VerifiedIcon from '@mui/icons-material/Verified'
import VideocamIcon from '@mui/icons-material/Videocam'
import ViewStreamIcon from '@mui/icons-material/ViewStream'
import WarningIcon from '@mui/icons-material/Warning'
import Grid from '@mui/material/Grid'
import { styled } from '@mui/material/styles'
import Typography from '@mui/material/Typography'

type IconComponent = typeof ExpandMoreIcon

type IconEntry = {
  Icon: IconComponent
  count: number
  name: string
}

const iconEntries: IconEntry[] = [
  { name: 'ExpandMore', count: 31, Icon: ExpandMoreIcon },
  { name: 'KeyboardArrowDown', count: 27, Icon: KeyboardArrowDownIcon },
  { name: 'Close', count: 25, Icon: CloseIcon },
  { name: 'ExpandLess', count: 24, Icon: ExpandLessIcon },
  { name: 'KeyboardArrowUp', count: 21, Icon: KeyboardArrowUpIcon },
  { name: 'KeyboardArrowRight', count: 18, Icon: KeyboardArrowRightIcon },
  { name: 'ArrowForward', count: 16, Icon: ArrowForwardIcon },
  { name: 'MoreHoriz', count: 15, Icon: MoreHorizIcon },
  { name: 'ChevronRight', count: 11, Icon: ChevronRightIcon },
  { name: 'ArrowBack', count: 9, Icon: ArrowBackIcon },
  { name: 'Search', count: 7, Icon: SearchIcon },
  { name: 'Add', count: 5, Icon: AddIcon },
  { name: 'DragIndicator', count: 5, Icon: DragIndicatorIcon },
  { name: 'ChevronLeft', count: 4, Icon: ChevronLeftIcon },
  { name: 'LocationOn', count: 4, Icon: LocationOnIcon },
  { name: 'Warning', count: 4, Icon: WarningIcon },
  { name: 'Check', count: 3, Icon: CheckIcon },
  { name: 'Crop', count: 2, Icon: CropIcon },
  { name: 'DeleteOutline', count: 2, Icon: DeleteOutlineIcon },
  { name: 'Info', count: 2, Icon: InfoIcon },
  { name: 'KeyboardArrowLeft', count: 2, Icon: KeyboardArrowLeftIcon },
  { name: 'PersonOutlined', count: 2, Icon: PersonOutlinedIcon },
  { name: 'Share', count: 2, Icon: ShareIcon },
  { name: 'Star', count: 2, Icon: StarIcon },
  { name: 'TodayOutlined', count: 2, Icon: TodayOutlinedIcon },
  { name: 'Tune', count: 2, Icon: TuneIcon },
  { name: 'ArrowDownward', count: 1, Icon: ArrowDownwardIcon },
  { name: 'ArrowUpward', count: 1, Icon: ArrowUpwardIcon },
  { name: 'Cancel', count: 1, Icon: CancelIcon },
  { name: 'CheckBox', count: 1, Icon: CheckBoxIcon },
  { name: 'CheckBoxOutlineBlank', count: 1, Icon: CheckBoxOutlineBlankIcon },
  { name: 'CheckCircle', count: 1, Icon: CheckCircleIcon },
  { name: 'CheckCircleOutline', count: 1, Icon: CheckCircleOutlineIcon },
  { name: 'ChevronLeftRounded', count: 1, Icon: ChevronLeftRoundedIcon },
  { name: 'Comment', count: 1, Icon: CommentIcon },
  { name: 'ContentCopy', count: 1, Icon: ContentCopyIcon },
  { name: 'DateRange', count: 1, Icon: DateRangeIcon },
  { name: 'Delete', count: 1, Icon: DeleteIcon },
  { name: 'EventRepeat', count: 1, Icon: EventRepeatIcon },
  { name: 'ExpandMoreRounded', count: 1, Icon: ExpandMoreRoundedIcon },
  { name: 'Facebook', count: 1, Icon: FacebookIcon },
  { name: 'FilterAlt', count: 1, Icon: FilterAltIcon },
  { name: 'FormatBold', count: 1, Icon: FormatBoldIcon },
  { name: 'FormatItalic', count: 1, Icon: FormatItalicIcon },
  { name: 'FormatListBulleted', count: 1, Icon: FormatListBulletedIcon },
  { name: 'FormatListNumbered', count: 1, Icon: FormatListNumberedIcon },
  { name: 'FormatUnderlined', count: 1, Icon: FormatUnderlinedIcon },
  { name: 'Fullscreen', count: 1, Icon: FullscreenIcon },
  { name: 'InfoOutlined', count: 1, Icon: InfoOutlinedIcon },
  { name: 'Instagram', count: 1, Icon: InstagramIcon },
  {
    name: 'KeyboardArrowRightRounded',
    count: 1,
    Icon: KeyboardArrowRightRoundedIcon,
  },
  { name: 'Link', count: 1, Icon: LinkIcon },
  { name: 'Menu', count: 1, Icon: MenuIcon },
  { name: 'Notes', count: 1, Icon: NotesIcon },
  { name: 'Notifications', count: 1, Icon: NotificationsIcon },
  { name: 'RadioButtonChecked', count: 1, Icon: RadioButtonCheckedIcon },
  { name: 'RadioButtonUnchecked', count: 1, Icon: RadioButtonUncheckedIcon },
  { name: 'Remove', count: 1, Icon: RemoveIcon },
  { name: 'Report', count: 1, Icon: ReportIcon },
  { name: 'Schedule', count: 1, Icon: ScheduleIcon },
  { name: 'Settings', count: 1, Icon: SettingsIcon },
  { name: 'SmartDisplay', count: 1, Icon: SmartDisplayIcon },
  { name: 'StarBorder', count: 1, Icon: StarBorderIcon },
  { name: 'TextFields', count: 1, Icon: TextFieldsIcon },
  { name: 'Twitter', count: 1, Icon: TwitterIcon },
  { name: 'UnfoldLess', count: 1, Icon: UnfoldLessIcon },
  { name: 'UnfoldMore', count: 1, Icon: UnfoldMoreIcon },
  { name: 'Verified', count: 1, Icon: VerifiedIcon },
  { name: 'Videocam', count: 1, Icon: VideocamIcon },
  { name: 'ViewStream', count: 1, Icon: ViewStreamIcon },
]

const IconsGrid = styled(Grid)(() => ({
  maxHeight: 220,
  overflowY: 'auto',
}))

const IconItem = styled('div')(({ theme }) => ({
  display: 'flex',
  alignItems: 'center',
  gap: theme.spacing(1),
  padding: theme.spacing(0.5, 0),
}))

const IconWrapper = styled('span')(({ theme }) => ({
  alignItems: 'center',
  backgroundColor: theme.palette.grey[100],
  borderRadius: theme.shape.borderRadius,
  color: theme.palette.grey[700],
  display: 'inline-flex',
  height: 32,
  justifyContent: 'center',
  width: 32,
}))

const CountText = styled(Typography)(({ theme }) => ({
  color: theme.palette.text.secondary,
}))

const IconsShowcase = () => (
  <IconsGrid container spacing={1}>
    {iconEntries.map(({ Icon, name, count }) => (
      <Grid item key={name} sm={6} xs={12}>
        <IconItem>
          <IconWrapper>
            <Icon fontSize="small" />
          </IconWrapper>
          <div>
            <Typography variant="body2">{name}</Typography>
            <CountText variant="caption">{count} uses</CountText>
          </div>
        </IconItem>
      </Grid>
    ))}
  </IconsGrid>
)

export default IconsShowcase
